import script from "./MHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MHeader.vue?vue&type=script&setup=true&lang=js"

import "./MHeader.vue?vue&type=style&index=0&id=1e45ebca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e45ebca"]])

export default __exports__